<script>

import { Overlay } from '../../'

export default {
    name: 'DC',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'Donchian Channel',
                preset: {
                    name: 'Donchian Channel, $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        topColor: 'rgba(0, 128, 0, 0.3)',
                        bottomColor: 'rgba(255, 0, 0, 0.3)',
                        color: 'rgba(220, 220, 220, 0.1)',
                        showMid: true,
                        backColor: 'rgba(215, 215, 215, 0.05)'
                    }
                }
            }
        },
        use_for() { return ['DC'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Channel' },
                update: `
                    let [m, h, l] = dc(high, low, length)
                    return [h, m, l]
                `
            }
        }
    }
}
</script>
